<template>
  <div>
    <div class="text-end ma-6">
      <v-btn @click="dialog = !dialog" medium color="primary">
        <v-icon left>mdi-pencil</v-icon>
        Cập nhật
      </v-btn>
    </div>
    <v-card class="ma-6 pa-6" outlined>
      <div>
        <span>
          Tiết theo PPCT:
        </span>
        <span class="font-weight-bold">
          {{ slot | _get('classNote.data.lessonIndex', '') }}
        </span>
      </div>
      <div>
        <span>
          Đầu bài/nội dung công việc:
        </span>
        <span class="font-weight-bold">
          {{ currentTopicLesson | _get('topicLesson.name', 'Chưa có thông tin') }}
        </span>
      </div>
    </v-card>
    <LessonUpdateDialog
      :state="dialog"
      :lessonProp="$_get(currentTopicLesson, 'topicLesson.id')"
      :lessonIndexProp="$_get(slot, 'classNote.data.lessonIndex')"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LessonUpdateDialog from '@/modules/classNote/teacherSide/LessonUpdateDialog.vue'
export default {
  data() {
    return {
      dialog: null
    }
  },
  components: {
    LessonUpdateDialog
  },
  methods: {},
  computed: {
    ...mapState('ClassNoteDetail', ['slot', 'currentTopicLesson']),
  }
}
</script>

<style></style>
